// Same breakpoint approach as guest-web's getGuestDetailsLayout(width) —
// a fixed pixel size per device tier instead of continuously scaling every
// value (aspectRatio/flex-derived sizing was tried and made the grid's
// proportions drift unpredictably inside the nested flex containers here).
export const TABLET_MIN_WIDTH = 768;

export interface ExploreCardSizes {
  readonly cardTall: { readonly width: number; readonly height: number };
  // No width for cardWide — it stretches to fill gridColumn (default
  // align-items: stretch), same width the properties/retail row below it
  // resolves to via flex. A fixed width here previously wasn't guaranteed
  // to equal the column's actual computed width on every device (most
  // visible on Android), leaving Hospitality's right edge misaligned with
  // Retail's.
  readonly cardWide: { readonly height: number };
  readonly cardHalf: { readonly height: number };
}

const PHONE_SIZES: ExploreCardSizes = {
  cardTall: { width: 150, height: 220 },
  cardWide: { height: 98 },
  cardHalf: { height: 100 },
};

// Same proportions as the phone tier, scaled up for tablet/iPad so the grid
// doesn't look cramped on a much wider screen.
const TABLET_SIZES: ExploreCardSizes = {
  cardTall: { width: 220, height: 320 },
  cardWide: { height: 140 },
  cardHalf: { height: 140 },
};

export function getExploreCardSizes(width: number): ExploreCardSizes {
  return width >= TABLET_MIN_WIDTH ? TABLET_SIZES : PHONE_SIZES;
}

// Same breakpoint approach for the "Key Institutions" grid cards on
// BloomExperienceDetailsScreen — width stays "48%" (already responsive),
// only height needs a device-tier value instead of a single fixed number.
export function getInstitutionCardHeight(width: number): number {
  return width >= TABLET_MIN_WIDTH ? 300 : 210;
}

// Both bloom-experience screens now show a fixed header + capped hero image
// above a white rounded-top content card (Explore Bloom World / Key
// Institutions), instead of the hero filling the whole scroll behind the
// content. A ratio of screen height (not a fixed px) so it scales the same
// way across phone sizes. Default matches BloomExperienceDetailsScreen's
// bottom-anchored hero copy (headline/body/CTA all sit near the hero's
// bottom edge, so it needs the taller default). BloomExperienceScreen's hub
// hero is top-anchored instead (eyebrow/headline/CTA pinned near the top),
// so it passes a smaller ratio to avoid a large empty gap between its CTA
// and the white "Explore Bloom World" card below.
const HERO_HEIGHT_RATIO = 0.48;

export function getHeroHeight(screenHeight: number, ratio: number = HERO_HEIGHT_RATIO): number {
  return Math.round(screenHeight * ratio);
}
